
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.668 6.918c.113.108.273.17.442.172a.656.656 0 00.455-.167l6.401-5.79a.548.548 0 00.005-.83.698.698 0 00-.886-.006L7.12 5.68 1.243.214A.7.7 0 00.789.05a.612.612 0 00-.444.177.539.539 0 00-.005.81l6.328 5.88z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.668 6.918c.113.108.273.17.442.172a.656.656 0 00.455-.167l6.401-5.79a.548.548 0 00.005-.83.698.698 0 00-.886-.006L7.12 5.68 1.243.214A.7.7 0 00.789.05a.612.612 0 00-.444.177.539.539 0 00-.005.81l6.328 5.88z","fill":"currentColor"}})])
          )
        }
      }
    